import { render, staticRenderFns } from "./ModalPacketTracking.vue?vue&type=template&id=47dfaac6&"
import script from "./ModalPacketTracking.vue?vue&type=script&lang=js&"
export * from "./ModalPacketTracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports